import { defineMessages } from 'react-intl';

export default defineMessages({
    addressLookUpOverride: {
        id: 'address-component.Override',
        defaultMessage: 'Override'
    },
    addressLookupAddressLine1:{
        id: 'address-component.AddressLine1',
        defaultMessage: 'Address Line 1' 
    },
    addressLookupAddressLine2:{
        id: 'address-component.AddressLine2',
        defaultMessage: 'Address Line 2' 
    },
    addressLookupAddressLine3:{
        id: 'address-component.AddressLine3',
        defaultMessage: 'Address Line 3' 
    },
    addressLookupCity:{
        id: 'address-component.City',
        defaultMessage: 'City' 
    },
    addressLookupState:{
        id: 'address-component.Province',
        defaultMessage: 'Province' 
    },
    addressLookupCountry:{
        id: 'address-component.Country',
        defaultMessage: 'Country' 
    },
    addressLookupPostalCode:{
        id: 'address-component.PostalCode',
        defaultMessage: 'Postal Code' 
    },
    addressLookupAddressType:{
        id: 'address-component.MailingAddress',
        defaultMessage: 'Mailing Address' 
    },
    addAddressButton:{
        id: 'address-component.Add',
        defaultMessage: 'Add' 
    },
    saveAddressButton:{
        id: 'address-component.Save',
        defaultMessage: 'Save' 
    },
    cancelAddressButton:{
        id: 'address-component.Cancel',
        defaultMessage: 'Cancel' 
    }
});
